export default __webpack_public_path__ + "static/media/user.6efe6fcb.jpg";